import React from 'react';
import { Link } from 'react-router-dom';

const ServicesOne = () => {
    return(
        <>
        {/*Services Section*/}
        <section className="services-section section-padding-all">
            <div className="internal-container">
            <div className="row clearfix">
                {/*Services Block*/}
                <div className="services-block col-lg-3 col-md-6 col-sm-12">
                <div className="inner-holder">
                    <div className="icon-holder">
                    <i className="flaticon-crane" />
                    </div>
                    <h3><Link to="#">Building Construction</Link></h3>
                    <div className="text">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.</div>
                    <div className="more-link"><Link className="read-more" to="#">Read more</Link></div>
                </div>
                </div>
                {/*Services Block*/}
                <div className="services-block col-lg-3 col-md-6 col-sm-12">
                <div className="inner-holder">
                    <div className="icon-holder">
                    <i className="flaticon-house" />
                    </div>
                    <h3><Link to="#">Building Renovation</Link></h3>
                    <div className="text">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.</div>
                    <div className="more-link"><Link className="read-more" to="#">Read more</Link></div>
                </div>
                </div>
                {/*Services Block*/}
                <div className="services-block col-lg-3 col-md-6 col-sm-12">
                <div className="inner-holder">
                    <div className="icon-holder">
                    <i className="flaticon-kit" />
                    </div>
                    <h3><Link to="#">Building Maintenance</Link></h3>
                    <div className="text">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.</div>
                    <div className="more-link"><Link className="read-more" to="#">Read more</Link></div>
                </div>
                </div>
                {/*Services Block*/}
                <div className="services-block col-lg-3 col-md-6 col-sm-12">
                <div className="inner-holder">
                    <div className="icon-holder">
                    <i className="flaticon-blueprint" />
                    </div>
                    <h3><Link to="#">Architecture Design</Link></h3>
                    <div className="text">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.</div>
                    <div className="more-link"><Link className="read-more" to="#">Read more</Link></div>
                </div>
                </div>
            </div>
            </div>
        </section>
        {/*End Services Section*/}
        </>
    )
}

export default ServicesOne;